import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { PromotionItem } from "../../../../common/components/PromotionItem";

export const PromotionListDialog = ({
  setShow,
  show,
  setFieldValue,
  promotionid,
  promotionListsV2,
}) => {
  const intl = useIntl();

  const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        data-bs-theme="dark"
        className="zIndex-9999"
        backdropClassName="zIndex-9999"
        autoFocus={false}
        enforceFocus={false}
        restoreFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-white">
            {intl.formatMessage({
              id: "promotion",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-white">
          {promotionListsV2?.map((promo) => (
            <PromotionItem
              key={promo.promotionid}
              promo={promo}
              className={
                promotionid === promo.promotionid ? "border-warning shadow" : ""
              }
              onClick={() => {
                setFieldValue(
                  "promotionid",
                  promotionid !== promo.promotionid ? promo.promotionid : ""
                );
                setShow(false);
              }}
            />
          ))}
          {promotionListsV2 && promotionListsV2.length <= 0 && (
            <div className="text-center p-4">
              {intl.formatMessage({ id: "noRecordFound" })}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
